module.exports = __webpack_public_path__ + "media/images/landing/dno/product-8-9519821f7572ac5977cee640889c00ea.png";